import splitToEcdHelper from '../../../helpers/splitToEcd';
import { splitsList } from '../../../constants';

export default state => Object.values(splitsList).reduce((splits, splitKey) => ({
  ...splits,
  [splitKey]: splitToEcdHelper(splitKey, state),
}), {});
